import useSplitMap from 'hooks/use-split-map'
import { transformExtent } from 'ol/proj'

const DEFAULT_PADDING = [65, 60, 110, 15]

export default function FocusFieldB(props) {
  const { boundary, defaultExtent } = props

  const { map_a } = useSplitMap()

  useEffect(() => {
    if (boundary) {
      map_a
        .getView()
        .fit(boundary.getGeometry().getExtent(), { padding: DEFAULT_PADDING })
    } else if (defaultExtent) {
      map_a
        .getView()
        .fit(transformExtent(defaultExtent, 'EPSG:4326', 'EPSG:3857'))
    }
  }, [map_a, boundary, defaultExtent])

  return null
}
